export default $axios => () => ({
    async getUrl(orderId) {
        let response = await $axios.$get(`/rest/student/own-sources-checker/${orderId}/url`);

        return response.url;
    },
});
